import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';

import styles from './HamburgerMenu.module.scss';

export interface HamburgerMenuProps {
  onClick: () => void;
  isSmallScreen: boolean;
  isOpen: boolean;
}

export const HamburgerMenu = ({ onClick, isSmallScreen, isOpen }: HamburgerMenuProps) =>
  isSmallScreen ? (
    <Button className={styles.menu} onClick={onClick}>
      {isOpen ? <CloseIcon aria-label="close-icon" /> : <MenuIcon aria-label="menu-icon" />}
    </Button>
  ) : null;
